import { useEffect } from "react";
import { LocationDto } from "@apiModels/LocationDto.csharp";
import {
  FormStateType,
  FormDispatch,
  FormReducer,
  FormFields,
} from "../Helpers/formTypes";
import { clear } from "../Helpers/formFunctions";
import { DoctorDto } from "@apiModels/DoctorDto.csharp";
import { isLocationSelected } from "../Helpers/locationHelpers";

export function useLocationDropdown(
  filteredLocations: LocationDto[],
  state: FormStateType,
  dispatch: FormDispatch,
  setValue: any
) {
  useEffect(() => {
    if (isLocationSelected(state.location)) {
      if (state.location.isLocation) {
        const relatedCenters = filteredLocations.filter((l) =>
          state.location.centers.includes(l.id)
        );
        if (relatedCenters.length === 1) {
          onLocationSelect(relatedCenters[0]);
        }
      }
    } else {
      const centers = filteredLocations.filter(
        (l) => l.id !== "-1" && !l.isLocation
      );
      const locations = filteredLocations.filter(
        (l) => l.id !== "-1" && l.isLocation
      );

      if (centers.length === 1) {
        onLocationSelect(centers[0]);
      } else if (locations.length === 1 && centers.length > 1) {
        onLocationSelect(locations[0]);
      }
    }
  }, [filteredLocations]);

  const onDoctorSelect = (doctor: DoctorDto) => {
    clear(FormFields.appointment, dispatch, setValue);
    setValue(FormFields.doctor, doctor);
    dispatch({
      type: FormReducer.update,
      field: FormFields.doctor,
      payload: doctor,
    });
  };

  const onLocationSelect = (location: LocationDto) => {
    setValue(FormFields.location, location);
    dispatch({
      type: FormReducer.update,
      field: FormFields.location,
      payload: location,
    });
  };

  return {
    onLocationSelect,
    onDoctorSelect,
  };
}
